import { render, staticRenderFns } from "./Dialog-Menu-Gallery.vue?vue&type=template&id=75240130&"
import script from "./Dialog-Menu-Gallery.vue?vue&type=script&lang=js&"
export * from "./Dialog-Menu-Gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports